import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PhoneInput from 'react-phone-number-input/input'
import { parsePhoneNumber } from 'react-phone-number-input'
import { Formik, Form, ErrorMessage } from 'formik';
import { AddPhoneNumberSchema } from '../../validation';

import { sendOTPForSocial, updateFormData } from '../../actions'
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';

import ShowErrorToasts from '../../../global/errorToast';
import ShowSuccessToasts from '../../../global/successToast';
import { MAGIC_NUMBER } from '../../../../constants/magicNumbers';
import { navigateTo } from '../../../global/actions';

const mapStateToProps = state => ({
  registration: state.Registration,
});

class AddPhoneNumber extends Component {
  constructor(props) {
    super(props);

    this.onBack = this.onBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { tempUserId } = this.props.registration;
    if (!tempUserId)
      dispatch(navigateTo(PAGE_ROUTES.LOGIN));
  }

  onBack = () => {
    let { history } = this.props;
    history.goBack();
  }

  handleSubmit = (values, form) => {
    let { dispatch } = this.props;
    let { phoneNumber } = values;
    let { tempUserId, formData } = this.props.registration;
    dispatch(updateFormData({ ...formData, phoneNumber: phoneNumber }));
    dispatch(sendOTPForSocial(phoneNumber, tempUserId)).then(response => {
      setTimeout(() => {
        dispatch(navigateTo(`${PAGE_ROUTES.VERIFY_OTP}?social=true`))
      }, MAGIC_NUMBER.QUICK_REDIRECT_DELAY)
    })
  }

  render() {

    let values = this.props.registration.formData;

    return (
      <div className="main-container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Create Phone Number</h1>
                <p className="detail-text">Please set a phone number for your account.</p>
                  <Formik
                    validationSchema={AddPhoneNumberSchema}
                    initialValues={values}
                    onSubmit={this.handleSubmit}>
                    {formProps => (
                      <Form>
                        <div className="signin-page">
                          <div className="form-section">
                            <div>
                              <div className="form-group">
                                <label className={`floating-label form-control ${formProps.values.phoneNumber ? 'floating' : ''}`} htmlFor="phoneNumber">
                                  <PhoneInput
                                    country="US"
                                    name="phoneNumber"
                                    id="phoneNumber"
                                    className="form-control"
                                    value={`+1${formProps.values.phoneNumber}`}
                                    onChange={(value) => {
                                      if (!!value) {
                                        const num = parsePhoneNumber(value);
                                        if (num) {
                                          formProps.setFieldValue('phoneNumber', num.nationalNumber);
                                        }
                                      } else {
                                        formProps.setFieldValue("phoneNumber", '');
                                      }
                                    }}
                                  />
                                  <span>Phone Number</span>
                                  <ErrorMessage name='phoneNumber' render={msg => <div className="invalid-feedback">{msg}</div>} />
                                </label>
                              </div>
                            </div>
                            <div className="combo-button">
                              <div className="signin-button">
                                <button type="submit" className="btn primary">Send OTP</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(AddPhoneNumber));
